import themeFile from "./ThemeFile";
import { careCenterThemes } from "./careCenterTheme";
import { orgThemes } from "./orgTheme";

export function getDefaultTheme() {
  return themeFile();
}

export function getOrgTheme(orgId) {
  return orgId && orgThemes[`org_${orgId}`] ? orgThemes[`org_${orgId}`] : null;
}

export function getCareCenterTheme(careCenterId) {
  return careCenterId && careCenterThemes[`cc_${careCenterId}`]
    ? careCenterThemes[`cc_${careCenterId}`]
    : null;
}
